import debounce from 'lodash.debounce';
import {
  trackMarkerHover as trackHover,
  trackMarkerClick as trackClick,
} from '@rsos/components/capstone/common/Map/useDeckGL/spatialTracking';

/**
 * EEN uses DeckGL which repaints hovers in every frame refresh
 * which happens repeatedly during a hover event, this function
 * makes sure to debounce calls to the same hover event.
 */
export const trackMarkerHover = debounce((spatialLayerKey, info) => {
  trackHover(spatialLayerKey, info);
}, 500);

/**
 * Track clicks, debounced to avoid recording double clicking.
 */
export const trackMarkerClick = debounce((spatialLayerKey, info) => {
  trackClick(spatialLayerKey, info);
}, 500);
